module.exports = __webpack_public_path__ + "static/media/MenuDropdown.6fadb5d7.svg";